import React from "react";
import PropTypes from "prop-types";
import t from "Utils/translation";
import { Icon, trash, more, enable, disable } from "Icons/index";
import DropdownMenu from "Components/dropdownMenu/DropdownMenu";
import DomainStatusBadge from "Components/domainStatusBadge/DomainStatusBadge";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { withRouter } from "react-router-dom";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
};

class ArchiveDomainRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    };
  }

  onDropdownOpenChange = (newVal) => {
    this.setState({ isMenuOpen: newVal });
  };

  goTo = () => {
    this.props.history.push({
      pathname: `archive/domains/${this.props.domain.code}/email_accounts`,
      state: {
        prevPagination: this.props.location.search,
      },
    });
  };

  deleteDomain = () => {
    this.props.deleteDomain(this.props.dom);
  };

  render() {
    const { domain: dom, isAdmin } = this.props;
    const loggedUser = this.context.getLoggedUser();

    let canEnableArchive = true;
    let canDeleteArchive = true;
    if (loggedUser.type === "TeamMember") {
      if (!loggedUser.permissions.includes("delete_vault_email_accounts")) {
        canDeleteArchive = false;
      }

      if (!loggedUser.permissions.includes("disable_vault_email_accounts")) {
        canEnableArchive = false;
      }
    }

    const isLoading = dom.archive_status === "activating" || dom.status === "updating";

    const hideMenu = !canEnableArchive && !canDeleteArchive;
    return (
      <tr key={dom.code}>
        <td data-label={t("table.header.status")}>
          <DomainStatusBadge status={dom.archive_status} statusDetail={dom.archive_status} archive />
        </td>
        <td data-label={t("table.header.domain")} className="textOverflow">
          {dom.archive_status === "disabled" || dom.status === "updating" || dom.archive_status === "activating" ? (
            dom.name
          ) : (
            <span className="internalLink" onClick={this.goTo}>
              {dom.name}
            </span>
          )}
        </td>
        {isAdmin && (
          <td data-label="customer" className="hideOnMobile">
            {dom.customer_fullname}
          </td>
        )}
        <td data-label={t("table.header.accounts")}>{dom.no_email_accounts_archive}</td>
        <td>
          {!isLoading && (
            <DropdownMenu
              isOpen={this.state.isMenuOpen}
              onOpenChange={this.onDropdownOpenChange}
              hideToggle={hideMenu}
              actions={[
                {
                  isHidden: !canEnableArchive || dom.archive_status !== "enabled",
                  onClick: () => this.props.toggleStatus("disabled"),
                  icon: disable,
                  label: t("ddMenu.disable"),
                },
                {
                  isHidden: !canEnableArchive || dom.archive_status !== "disabled",
                  onClick: () => this.props.toggleStatus("enable"),
                  icon: enable,
                  label: t("ddMenu.enable"),
                },
                {
                  isHidden: !canDeleteArchive,
                  onClick: this.deleteDomain,
                  icon: trash,
                  label: t("ddMenu.delete"),
                },
              ]}
            >
              <ButtonIcon icon={more} />
            </DropdownMenu>
          )}
        </td>
      </tr>
    );
  }
}

ArchiveDomainRow.contextTypes = ContextTypes;
export default withRouter(ArchiveDomainRow);
